var render = function render(){var _vm=this,_c=_vm._self._c;return _c('client-only',[_c('div',{staticClass:"language-switcher",class:{ hide: !_vm.$store.state.showLanguages }})])
}
var staticRenderFns = []

export { render, staticRenderFns }